import AddButton from '../../components/global-components/AddButton';
import { formatDateToYYMMDD } from '../../utils/helper';
import { getJobsStatus } from '../../utils/utils';
import { DataTable, SearchInput } from '../../components';
import { Project, ProjectStatus } from '../interfaces';
import {
  AddJobModal,
  JobHistoryFilters,
  JobsTableRowLink,
} from './components';
import { useJobHistory } from './hooks';
import './JobHistory.scss';

interface Props {
  statusesFilter?: (status: ProjectStatus) => boolean;
  isAdmin?: boolean;
  isAddShipment?: boolean;
}

export default function JobHistory({
  statusesFilter = () => true,
  isAdmin = false,
  isAddShipment = false,
}: Props) {
  const {
    startDate,
    endDate,
    onChangeDates,
    onChangeRawDates,
    account,
    onChangeAccount,
    status,
    onChangeStatus,
    projectCode,
    onChangeProjectCode,
    areFiltersChanged,
    onClickFilter,
    search,
    onChangeSearch,
    onClickAdd,
    addJobModalOpen,
    onCloseAddJobModal,
    onAddJobSuccess,
    jobsList,
    loadingJobs,
    page,
    onChangePage,
    pageSize,
    onChangePageSize,
    jobCount,
    jobPages,
  } = useJobHistory(isAdmin);

  const jobsTableHeaders = [
    {
      key: 'creationDate',
      text: 'Created On',
      getCellContent: (value: string) =>
        value ? formatDateToYYMMDD(new Date(value)) : '-',
    },
    {
      key: 'bbeNumber',
      text: 'My BBE#',
      getCellContent: (value: string) => value || 'N/A',
    },
    {
      key: 'project',
      text: 'Project',
      getCellContent: (project: Project) => project?.name || 'N/A',
    },
    {
      key: 'purchaseOrder',
      text: 'PO Number',
      getCellContent: (value: string) => value || 'N/A',
    },
    {
      key: 'referenceOne',
      text: 'Reference One',
      getCellContent: (value: string) => value || 'N/A',
    },
    {
      key: 'referenceTwo',
      text: 'Reference Two',
      getCellContent: (value: string) => value || 'N/A',
    },
    {
      key: 'statusName',
      text: 'Status',
      getCellContent: (value: string) => getJobsStatus(value) || 'N/A',
    },
    {
      key: 'bbeNumber',
      text: '',
      getCellContent: (jobId: string) => (
        <JobsTableRowLink
          jobId={jobId}
          isAdmin={isAdmin}
          isAddShipment={isAddShipment}
        />
      ),
    },
  ];

  return (
    <div className='JobHistory'>
      <div className='FiltersAndSearchContainer'>
        <JobHistoryFilters
          startDate={startDate}
          endDate={endDate}
          onChangeDates={onChangeDates}
          onChangeRawDates={onChangeRawDates}
          projectCode={projectCode}
          onChangeProjectCode={onChangeProjectCode}
          status={status}
          onChangeStatus={onChangeStatus}
          account={account}
          onChangeAccount={onChangeAccount}
          areFiltersChanged={areFiltersChanged}
          onClickFilter={onClickFilter}
          statusesFilter={statusesFilter}
          isAdmin={isAdmin}
        />
        <div className='SecondRow'>
          <div className='SearchContainer'>
            <SearchInput
              value={search}
              onChange={onChangeSearch}
            />
          </div>
          {!isAdmin && (
            <div className='AddButtonContainer'>
              <AddButton clickHandler={onClickAdd}/>
            </div>
          )}
        </div>
      </div>
      <div className='DataTableContainer'>
        <DataTable
          headers={jobsTableHeaders}
          data={jobsList}
          loading={loadingJobs}
          page={page}
          onChangePage={onChangePage}
          pageSize={pageSize}
          onChangePageSize={onChangePageSize}
          count={jobCount}
          pages={jobPages}
        />
      </div>
      {addJobModalOpen && (
        <AddJobModal
          onClose={onCloseAddJobModal}
          onSuccess={onAddJobSuccess}
        />
      )}
    </div>
  );
}
